"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscreteRating = void 0;
var DiscreteRating = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5
};
exports.DiscreteRating = DiscreteRating;